import React, { useEffect } from 'react';

import { useAppDispatch } from '../../app/store';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from '../../features/ui/model/uiSlice';
import { CompetitionsListWidget } from '../../widgets/competitions-b2b/list';

const CompetitonsB2BPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Соревнования B2B'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать соревнование'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <CompetitionsListWidget />;
};

export { CompetitonsB2BPage };
